export const CHANGE_HOTEL_INFO_STATE = 'CHANGE_HOTEL_INFO_STATE';

export interface ChangeHotelInfoState {
  type: typeof CHANGE_HOTEL_INFO_STATE;
  isOpen: boolean;
};

export type HotelInfoState = {
  isOpen: boolean;
};

export type HotelInfoActionTypes = ChangeHotelInfoState;